/* ============================================
   Hecan B2B Theme - Base JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {

  /* Mobile navigation toggle */
  var navToggle = document.getElementById('nav-toggle');
  var navMenu = document.getElementById('nav-menu');

  if (navToggle && navMenu) {
    navToggle.addEventListener('click', function() {
      var isOpen = navMenu.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', isOpen);
      document.body.classList.toggle('nav-open', isOpen);
    });
  }

  /* Smooth scroll for same-page anchor links */
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* FAQ accordion */
  document.querySelectorAll('.faq-item-toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var parent = this.closest('.faq-item');
      var isOpen = parent.classList.contains('is-open');
      parent.classList.toggle('is-open', !isOpen);
      this.setAttribute('aria-expanded', !isOpen);
    });
  });

  /* Fade-in on scroll (simple intersection observer) */
  if ('IntersectionObserver' in window) {
    var fadeElements = document.querySelectorAll('.fade-in');
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    fadeElements.forEach(function(el) { observer.observe(el); });
  }

  /* Inquiry form handling */
  var inquiryForm = document.getElementById('inquiry-form');
  if (inquiryForm) {
    inquiryForm.addEventListener('submit', function(e) {
      var btn = this.querySelector('button[type="submit"]');
      var originalText = btn ? btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.textContent = btn.getAttribute('data-loading') || 'Sending...';
      }
    });
  }

  /* Product image gallery */
  var productGallery = document.getElementById('product-gallery');
  if (productGallery) {
    var thumbs = productGallery.querySelectorAll('.gallery-thumb');
    var mainImg = productGallery.querySelector('.gallery-main img');
    if (thumbs.length && mainImg) {
      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var newSrc = this.getAttribute('data-image-src');
          var newSrcset = this.getAttribute('data-image-srcset');
          if (newSrc) {
            mainImg.src = newSrc;
            if (newSrcset) mainImg.srcset = newSrcset;
          }
          thumbs.forEach(function(t) { t.classList.remove('is-active'); });
          this.classList.add('is-active');
        });
      });
    }
  }

});

/* Debounce helper for resize events */
function debounce(fn, delay) {
  var timer;
  return function() {
    var context = this, args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function() { fn.apply(context, args); }, delay);
  };
}
